/**
 * Normalizes a location value coming from the backend.
 *
 * The API sometimes omits a location or sends a placeholder ("-", "—", "").
 * Returns a clean, trimmed string when a real location is present, otherwise
 * an empty string — so callers can hide the location element entirely instead
 * of rendering a "-" placeholder on screen.
 *
 * @param {*} value - raw location from the API
 * @returns {string} the cleaned location, or "" when there is no real value
 */
export function cleanLocation(value) {
  if (value == null) return "";
  const trimmed = String(value).trim();
  if (trimmed === "" || trimmed === "-" || trimmed === "—") return "";
  return trimmed;
}

/**
 * Whether a real location is present (i.e. should be shown on screen).
 * @param {*} value - raw location from the API
 * @returns {boolean}
 */
export function hasLocation(value) {
  return cleanLocation(value) !== "";
}
